<template>
  <div class="tab-pane active" id="identitas" role="tabpanel">
    <div class="card-on-card">
      <div class="card-body">
        <h5 class="card-title text-center mt-3 mb-3">Profile Toko</h5>
        <form
          action="profile/identitas/update"
          method="POST"
          id="updateIdentitas"
        >
          <div class="form-row mt-3">
            <div class="form-group col-md-3">
              <label for="name">Nama Toko</label>
              <input
                type="text"
                class="form-control"
                :value="user.name"
                id="mallName"
                name="mallName"
                placeholder="Nama Toko"
              />
            </div>
            <div class="form-group col-md-3">
              <label for="jenisusaha" class="col">Jenis Usaha</label>
              <div class="col">
                <select
                  class="form-control custom-select"
                  name="jenisUsaha"
                  id="jenisUsaha"
                >
                  <option value="PT" selected="">
                    {{ user.business.type }}
                  </option>
                  <option value="Individu">Individu</option>
                  <option value="PT">PT</option>
                  <option value="CV">CV</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="kategoriUsaha" class="col">Kategori Usaha</label>
              <div class="col">
                <select
                  class="form-control custom-select"
                  id="businessCategory"
                  name="businessCategory"
                >
                  <option value="Mikro">Usaha Mikro</option>
                  <option value="Kecil">Usaha Kecil</option>
                  <option value="Menengah">Usaha Menengah</option>
                  <option value="Besar">Usaha Besar</option>
                  <option value="NonUMKM">Non UMKM</option>
                  <option value="Koperasi">Koperasi</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="status_usaha" class="col">Status Usaha</label>
              <div class="col">
                <select
                  class="form-control custom-select"
                  id="statusUsaha"
                  name="status_usaha"
                >
                  <option value="pkp" selected="">
                    {{ user.type }}
                  </option>
                  <option value="PKP">PKP</option>
                  <option value="Non-PKP">Non-PKP</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="npwp">NPWP</label>
              <input
                type="text"
                class="form-control"
                :value="user.legality.npwp.id"
                name="npwp"
                id="npwp"
                @input="onNpwpInput"
              />
            </div>
            <div class="form-group col-md-5">
              <label for="siup">SIUP/NIB</label>
              <input
                type="text"
                class="form-control"
                name="siup"
                :value="user.legality.siup.id"
                id="siup"
              />
            </div>
            <div class="form-group col-md-4">
              <label for="email_toko">Email Toko</label>
              <input
                type="text"
                class="form-control"
                :value="user.email"
                name="email_toko"
                id="email_toko"
              />
            </div>
          </div>

          <h5 class="card-title text-center mt-3 mb-3">
            Penanggung Jawab Toko
          </h5>

          <div class="form-row mt-3">
            <div class="form-group col-md-4">
              <label for="nama_pic">Nama PIC</label>
              <input
                type="text"
                class="form-control"
                :value="user.pic.name"
                id="nama_pic"
                name="nama_pic"
                placeholder="Nama PIC"
              />
            </div>
            <div class="form-group col-md-4">
              <label for="jabatan_pic">Jabatan PIC</label>
              <input
                type="text"
                class="form-control"
                :value="user.pic.position"
                id="jabatan_pic"
                name="jabatan_pic"
                placeholder="Jabatan PIC"
              />
            </div>
            <div class="form-group col-md-4">
              <label for="no_telp">No Telp</label>
              <input
                type="number"
                class="form-control"
                :value="user.pic.phone"
                id="no_telp"
                name="no_telp"
                placeholder="No Telepon"
              />
            </div>

            <div class="form-group col-md-4">
              <label for="NIK">Nomor Induk Kependudukan</label>
              <input
                type="number"
                class="form-control"
                :value="user.pic.ktp"
                id="NIK"
                name="NIK"
                placeholder="No Telepon"
              />
            </div>
          </div>
          <div class="text-center my-3">
            <button
              @click="editIdentity"
              type="button"
              class="btn btn-primary btn-lg"
            >
              <span>{{ loading ? "" : "Update Toko" }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    editIdentity: Function,
    loading: Boolean,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    onNpwpInput(event) {
      const numericValue = event.target.value.replace(/\D/g, ""); // hanya angka
      this.user.legality.npwp.id = numericValue; // reaktif update model
      event.target.value = numericValue; // sinkronisasi dengan input DOM
    },
  },
};
</script>
